<template>
  <v-dialog v-model="localValue" max-width="768" lazy>
    <v-card>
      <v-toolbar color="primary" flat dense card dark>
        <v-toolbar-title>
          {{ $t('fields.typeSubscriptions.linkedAccounts') }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="localValue = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider />
      <v-card-text class="pa-0">
        <v-data-table
          :headers="headers"
          :items="items"
          :rows-per-page-items="[5]"
          disable-initial-sort
          :loading="loading"
        >
          <template slot="items" slot-scope="props">
            <td class="text-xs-center">
              <button-state :state="!!props.item.master" />
            </td>
            <td>
              <v-chip v-if="props.item.name" small color="transparent">
                <v-avatar v-if="props.item.photo" size="32">
                  <img :src="props.item.photo" alt />
                </v-avatar>

                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ props.item.name + ' ' + props.item.lastname1 }}
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-chip>
            </td>
            <td>
              <v-list-tile-sub-title v-if="props.item.teams">
                <v-chip
                  v-for="team of props.item.teams"
                  :key="team._id"
                  class="my-0"
                  color="transparent"
                >
                  <v-avatar>
                    <v-img :src="team.logo" />
                  </v-avatar>
                  <v-list-tile-content class="caption">
                    <v-list-tile-title>
                      <span> {{ team.name }}</span>
                    </v-list-tile-title>
                    <v-list-tile-sub-title
                      class="caption primary--text text--lighten-1 text-truncate"
                    >
                      {{ team.categoryName.join(' - ') }}
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-chip>
              </v-list-tile-sub-title>
              <v-list-tile-sub-title v-else-if="props.item.entities">
                <v-chip
                  v-for="entity of props.item.entities"
                  :key="entity._id"
                  class="my-0"
                  color="transparent"
                  small
                >
                  <v-avatar>
                    <v-img :src="entity.logo" />
                  </v-avatar>
                  <span class="caption primary--text text--lighten-1">{{
                    entity.name
                  }}</span>
                </v-chip>
              </v-list-tile-sub-title>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <meta-button type="cancel" @click="localValue = false" />
        <meta-button
          type="add"
          :disabled="items.length > 2"
          @click="linkAccount"
        />
      </v-card-actions>
    </v-card>
    <v-dialog v-model="expand" max-width="290">
      <v-card>
        <v-card-title class="text-h5">
          {{ $t('fields.typeSubscriptions.linkedAccounts') }}
        </v-card-title>

        <v-card-text>
          <v-select
            v-model="parent"
            :items="parentList"
            :label="$t('action.buttons.select')"
            :item-text="(item) => `${item.name} ${item.lastname1}`"
            item-value="_id"
          />
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <meta-button type="cancel" @click="expand = false" />
          <meta-button type="save" @click="setLinkAccount" />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'DialogLinkedAccounts',
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
    },
    subscriptionId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      items: [],
      loading: false,
      expand: false,
      parent: null,
      parentList: [],
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
        if (!value) this.clear()
      },
    },
    headers() {
      return [
        {
          text: this.$t('titles.subscriptions.master'),
          align: 'center',
          value: 'master',
        },
        {
          text: this.$tc('models.user'),
          value: 'name',
        },
        {
          text: `${this.$tc('models.entity', 2)} / ${this.$tc(
            'models.team',
            2
          )}`,
          sortable: false,
        },
      ]
    },
  },
  watch: {
    value(val) {
      if (val && this.subscriptionId) {
        this.init()
      }
    },
  },
  methods: {
    ...mapActions({
      getLinkedAccountList: 'subscriptions/getLinkedAccountList',
      setLinkedAccount: 'subscriptions/setLinkedAccount',
      getParentList: 'subscriptions/getParentList',
    }),
    init() {
      this.loading = true
      this.getLinkedAccountList(this.subscriptionId)
        .then((items) => {
          console.log('items :', items)
          this.items = items
        })
        .finally(() => {
          this.loading = false
        })
    },
    clear() {
      this.items = []
      this.loading = false
    },
    linkAccount() {
      this.getParentList(this.items.find((user) => user.master)._id)
        .then((parents) => {
          this.parentList = parents
        })
        .finally(() => {
          this.expand = true
        })
    },
    setLinkAccount() {
      this.setLinkedAccount({
        userId: this.parent,
        subId: this.subscriptionId,
      }).finally(() => {
        this.expand = false
        this.init()
      })
    },
  },
}
</script>
